import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getHotelOfferEntitiesHaveOffers, getModuleState } from 'modules/sapiSearch/selectors';
import { ModuleState } from 'modules/sapiSearch/slice';
import { Alert } from '@daedalus/atlas/Alert';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { useToastController } from '@daedalus/atlas/context/toastController';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import OpacityAnimation from '@daedalus/atlas/helpers/OpacityAnimation';
import { Icon } from '@daedalus/atlas/Icon';
import { Link } from '@daedalus/atlas/Link';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY } from '@daedalus/core/src/auth/modules/actions';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
interface MessageProps {
  isMobile?: boolean;
  onTryAgain: () => void;
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w18x6b12",
  propsAsIs: false
});
const Title = /*#__PURE__*/styled('div')({
  name: "Title",
  class: "t1px0n31",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Button;
const RetryButton = /*#__PURE__*/styled(_exp5())({
  name: "RetryButton",
  class: "rxoolpv",
  propsAsIs: true
});
const TimeoutMessage: React.FC<MessageProps> = ({
  isMobile = false,
  onTryAgain
}) => {
  return <Flex.Row gap="s100" wrap="wrap">
      <Title>
        <FormattedMessageWrapper id="backendError.title" defaultMessage="Something went wrong" />
        {!isMobile && <span>.</span>}
      </Title>
      <FormattedMessageWrapper id="gettingResultsError" defaultMessage="We're having trouble getting the latest results." />
      {isMobile ? <RetryButton variant="secondary" fullWidth={true} size="lg" onClick={onTryAgain}>
          <FormattedMessageWrapper id="tryAgain" defaultMessage="Try Again" />
        </RetryButton> : <Link variant="default" href="#" onClick={onTryAgain}>
          <FormattedMessageWrapper id="tryAgain" defaultMessage="Try Again" />
        </Link>}
    </Flex.Row>;
};
const SEARCH_TIMEOUT = 20000; // 20 seconds

export const SearchResultAlert = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    open,
    close
  } = useToastController();
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const moduleState = useSelector(getModuleState);
  const hasOffers = useSelector(getHotelOfferEntitiesHaveOffers);
  const timeout = useRef(null);
  const handleRefresh = () => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SearchResultTimeoutAlertTryAgainButton,
      action: Action.Clicked,
      team: Team.Search
    }));
    setTimeout(() => window.location.reload(), TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY);
  };
  useEffect(() => {
    // clear the timeout if the search is completed or if we have received some offers
    if (moduleState === ModuleState.SearchCompleted ||
    // we don't want to show the alert if we have received at least the first batch of offers
    hasOffers) {
      clearTimeout(timeout.current);
      timeout.current = null;
    } else if (!timeout.current) {
      setIsVisible(false);
      timeout.current = setTimeout(() => setIsVisible(true), SEARCH_TIMEOUT);
    }
  }, [moduleState, isVisible, hasOffers]);
  useEffect(() => {
    if (isVisible) {
      dispatch(trackEvent({
        category: Category.System,
        entity: Entity.SearchResultTimeoutAlert,
        action: Action.Displayed,
        team: Team.Search
      }));
    }
  }, [isVisible, dispatch]);
  useEffect(() => {
    if (isMobile) {
      if (isVisible) {
        open(<TimeoutMessage isMobile={isMobile} onTryAgain={handleRefresh} />, {
          icon: <Icon name="WarningTriangle" />,
          showCloseButton: false,
          singleToastMessage: true,
          autoClose: false
        });
      } else {
        close();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, dispatch, isMobile]);
  return isVisible && !isMobile && <OpacityAnimation delay={1500} duration={0.5}>
        <Wrapper>
          <Alert variant="danger" icon={<Icon name="WarningTriangle" />}>
            <TimeoutMessage onTryAgain={handleRefresh} />
          </Alert>
        </Wrapper>
      </OpacityAnimation>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");